import {
    CONFIRMED_GET_MEDICINE_TYPES,
    CONFIRMED_CREATE_MEDICINE_TYPE,
    CONFIRMED_DELETE_MEDICINE_TYPE,
    CONFIRMED_EDIT_MEDICINE_TYPE,
  } from "../types/MedicineTypeTypes";
  
  const initialState = {
    list: [],
    num_rows: 0,
  };
  
  export default function MedicineTypeReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_MEDICINE_TYPES:
        return {
          ...state,
          list: action.payload.list,
          num_rows: action.payload.num_rows,
        };
  
      case CONFIRMED_CREATE_MEDICINE_TYPE:
        return {
          ...state,
          list: [...state.list, action.payload],
        };
  
      case CONFIRMED_DELETE_MEDICINE_TYPE:
        return {
          ...state,
          list: state.list.filter(
            (item) =>
              item.medicine_type_id !== action.payload.medicine_type_id
          ),
        };
  
      case CONFIRMED_EDIT_MEDICINE_TYPE:
        const updatedList = [...state.list];
        const index = updatedList.findIndex(
          (item) =>
            item.medicine_type_id === action.payload.medicine_type_id
        );
  
        if (index !== -1) {
          updatedList[index] = action.payload;
        }
  
        return {
          ...state,
          list: updatedList,
        };
  
      default:
        return state;
    }
  }
  